

























import { Component, Prop, Vue } from "vue-property-decorator";
import { getVideoPort, setScreenON, setVideoPort, setVideoSwitchON } from "../sessionService";
import { CalendarData, Properties, SessionButton } from "../types";
import { FILEENDPOINT } from "@/app.config";

@Component
export default class MainArea extends Vue {
    @Prop() meetingName!: string;
    @Prop() currentMeeting!: CalendarData | null;
    @Prop() properties!: Properties;
    @Prop() translations!: any;
    @Prop() isBookingDisabled!: boolean;
    @Prop() screenOn!: boolean;
    @Prop() meetingToConfirm!: CalendarData | null;
    @Prop() timeUntilNextMeeting!: number;

    selectedButton: Number | null = null;
    loading = "";
    loadingTimer = 0;

    get buttons() {
        return [
            {
                text: this.properties.button1.text || this.translations.sourceSelectionButtonLaptopPCWirelessText,
                icon: this.properties.button1.icon ? FILEENDPOINT + this.properties.button1.icon : require("../assets/btn_clickshare.png"),
                hidden: this.properties.button1.hidden || false,
                port: 1
            },
            {
                text: this.properties.button2.text || this.translations.sourceSelectionButtonMeetingRoomPCText,
                icon: this.properties.button2.icon ? FILEENDPOINT + this.properties.button2.icon : require("../assets/btn_meeting_room.png"),
                hidden: this.properties.button2.hidden || false,
                port: 2
            },
            {
                text: this.properties.button3.text || this.translations.sourceSelectionButtonOtherAVDeviceText,
                icon: this.properties.button3.icon ? FILEENDPOINT + this.properties.button3.icon : require("../assets/btn_extradevice.png"),
                hidden: this.properties.button3.hidden || false,
                port: 3
            },
            {
                text: this.properties.button4.text || this.translations.sourceSelectionButtonLaptopPCCableText,
                icon: this.properties.button3.icon ? FILEENDPOINT + this.properties.button4.icon : require("../assets/btn_cable.png"),
                hidden: this.properties.button4.hidden || false,
                port: 4
            }
        ] as SessionButton[];
    }

    get activeButtons() {
        return this.buttons.filter(x => x.hidden === false);
    }

    mounted() {
        getVideoPort().then(port => {
            this.selectedButton = port;
        }).catch(() => {
            console.log("Error getting current port");
        });
    }

    selectButton(index: number) {
        if (index === 0) {
            this.selectedButton = index;
            return;
        }
        if (this.isBookingDisabled && !this.screenOn) return;
        this.loading = `btn-${index}`;
        clearTimeout(this.loadingTimer);
        this.loadingTimer = setTimeout(() => {
            this.loading = "";
        }, 3000);

        this.selectedButton = index;
        setScreenON();
        setVideoPort(index).then(() => {
            console.log("Changed port to", index);
        }).catch(() => {
            console.log("Error changing port");
            this.selectedButton = null;
        });
        setVideoSwitchON();
    }
}
